import React, { Component, Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import styled from 'styled-components';
import { startCase } from 'lodash';
import moment from 'moment';
import Link from '../../components/common/Link';
import TablePagination from '@material-ui/core/TablePagination';
import Empty from '../../components/common/Empty';
import * as OrganizationsActionCreators from '../../redux/organizations';
import { SORTABLE_FIELDS_ORGANIZATIONS, ROWS_PER_PAGE } from '../../constants';

const { REACT_APP_FRONTEND_URL } = process.env;

const TableContainer = styled.div`
  background-color: #eeeeee;
  padding: 20px;
`;

const TablePaper = styled(Paper)`
  && {
    width: 100%;
    margin-top: 30px;
    overflow-x: auto;
  }
`;

const OrganizationsTable = styled(Table)`
  && {
    min-width: 700px;
  }
`;

const OrganizationsTableHead = styled(TableHead)`
  && {
    background-color: rgba(125, 188, 255, 0.6);
  }
`;

const OrganizationsTableHeadFields = styled(TableCell)`
  && {
    color: black;
    font-weight: bold;
  }
`;

const EditButtonContainer = styled.div`
  margin-top: 5px;
`;

const SearchButton = styled(Button)`
  && {
    margin-left: 20px;
  }
`;

class OrganizationsPage extends Component {
  state = {
    showingPage: 0,
    searchField: '',
    adminEmailField: '',
    order: 'desc',
    orderBy: 'created_at'
  };

  componentDidMount() {
    this.clearSearchOrganization();
  }

  getCellNames = () => {
    return [
      'id',
      'name',
      'charity',
      'bill_contact_count',
      'juven_admin',
      'custom_contact_limit',
      'created_at',
      'admins',
      'actions'
    ];
  };

  onClickSearchOrganization = () => {
    const { actions } = this.props;
    const { searchField, adminEmailField, order, orderBy } = this.state;
    actions.getOrganizations(
      ROWS_PER_PAGE,
      0,
      orderBy,
      order,
      searchField,
      adminEmailField
    );
  };

  onEnter = e => {
    if (e.key === 'Enter') {
      this.onClickSearchOrganization();
    }
  };

  clearSearchOrganization = () => {
    const { actions } = this.props;
    this.setState({
      showingPage: 0,
      searchField: '',
      adminEmailField: '',
      order: 'desc',
      orderBy: 'created_at'
    });
    const { orderBy, order } = this.state;
    actions.getOrganizations(ROWS_PER_PAGE, 0, orderBy, order);
  };

  handleChangePage = (organization, page) => {
    const { actions } = this.props;
    const { searchField, adminEmailField, order, orderBy } = this.state;
    actions.getOrganizations(
      ROWS_PER_PAGE,
      page,
      orderBy,
      order,
      searchField,
      adminEmailField
    );
    this.setState({
      showingPage: page
    });
  };
  onClickSortHandle = orderBy => organization => {
    const { actions } = this.props;
    const order = this.state.order === 'asc' ? 'desc' : 'asc';
    const { showingPage, searchField, adminEmailField } = this.state;
    this.setState({ orderBy, order });
    actions.getOrganizations(
      ROWS_PER_PAGE,
      showingPage,
      orderBy,
      order,
      searchField,
      adminEmailField
    );
  };

  onChangeSearch = value => this.setState({ searchField: value });

  onChangeAdmin = value => this.setState({ adminEmailField: value });

  renderTableCellNames = () => {
    const cellNames = this.getCellNames();

    return cellNames.map((name, i) => {
      const displayName = startCase(name);
      if (SORTABLE_FIELDS_ORGANIZATIONS.includes(name)) {
        return (
          <OrganizationsTableHeadFields key={i}>
            <TableSortLabel
              active={this.state.orderBy === name}
              direction={this.state.order}
              onClick={this.onClickSortHandle(name)}
            >
              {displayName}
            </TableSortLabel>
          </OrganizationsTableHeadFields>
        );
      }

      return (
        <OrganizationsTableHeadFields key={i}>
          {displayName}
        </OrganizationsTableHeadFields>
      );
    });
  };

  renderTableBody = () => {
    const { organizations } = this.props;

    if (!organizations) return <TableRow />;
    const cellNames = this.getCellNames();
    return organizations.map((organization, i) => {
      return (
        <TableRow key={i}>
          {cellNames.map((field, index) => {
            let value;
            if (field === 'admins') {
              value = organization[field].map((admin, key) => (
                <div key={key}>{admin.email}</div>
              ));
            } else if (field === 'juven_admin') {
              var HasJuvenadmin = false;
              organization['admins'].forEach((admin, key) => {
                if (admin.email.indexOf('@juven.co') !== -1) {
                  HasJuvenadmin = true;
                }
              });
              if (HasJuvenadmin) {
                value = (
                  <span style={{ color: 'green' }}>
                    {HasJuvenadmin.toString()}
                  </span>
                );
              } else {
                value = (
                  <span style={{ color: 'red' }}>
                    {HasJuvenadmin.toString()}
                  </span>
                );
              }
            } else if (field === 'created_at') {
              value = moment(organization[field]).format('LLLL');
            } else if (typeof organization[field] === 'boolean') {
              if (organization[field]) {
                value = (
                  <span style={{ color: 'green' }}>
                    {organization[field].toString()}
                  </span>
                );
              } else {
                value = (
                  <span style={{ color: 'red' }}>
                    {organization[field].toString()}
                  </span>
                );
              }
            } else if (
              field === 'custom_contact_count' ||
              field === 'bill_contact_limit'
            ) {
              value = organization[field] || '-';
            } else if (field === 'actions') {
              return (
                <TableCell key={index}>
                  <EditButtonContainer>
                    <Link to={`/organizations/${organization.icered_id}/edit`}>
                      <Button variant="outlined" color="primary">
                        Edit
                      </Button>
                    </Link>
                  </EditButtonContainer>
                </TableCell>
              );
            } else if (field === 'name') {
              const organizationURL = [
                REACT_APP_FRONTEND_URL,
                organization.icered_id
              ].join('/');

              value = (
                <div>
                  <a href={organizationURL} target="_blank">
                    {organization.name}
                  </a>
                </div>
              );
            } else {
              value = organization[field];
            }
            return <TableCell key={index}>{value}</TableCell>;
          })}
        </TableRow>
      );
    });
  };

  renderTable = () => {
    const { ui, meta } = this.props;
    const { showingPage } = this.state;
    if (ui === 'complete') {
      return (
        <Fragment>
          <TablePagination
            rowsPerPageOptions={[ROWS_PER_PAGE]}
            component="div"
            count={meta ? meta.count : 0}
            rowsPerPage={ROWS_PER_PAGE}
            page={showingPage}
            backIconButtonProps={{
              'aria-label': 'Previous Page'
            }}
            nextIconButtonProps={{
              'aria-label': 'Next Page'
            }}
            onChangePage={this.handleChangePage}
          />
          <OrganizationsTable>
            <OrganizationsTableHead>
              <TableRow>{this.renderTableCellNames()}</TableRow>
            </OrganizationsTableHead>
            <TableBody>{this.renderTableBody()}</TableBody>
          </OrganizationsTable>
          <TablePagination
            rowsPerPageOptions={[ROWS_PER_PAGE]}
            component="div"
            count={meta ? meta.count : 0}
            rowsPerPage={ROWS_PER_PAGE}
            page={showingPage}
            backIconButtonProps={{
              'aria-label': 'Previous Page'
            }}
            nextIconButtonProps={{
              'aria-label': 'Next Page'
            }}
            onChangePage={this.handleChangePage}
          />
        </Fragment>
      );
    }

    return null;
  };

  renderEmpty = () => (this.props.ui === 'empty' ? <Empty /> : null);

  render() {
    const { searchField, adminEmailField } = this.state;
    return (
      <div>
        <TextField
          id="search"
          label="Search by Org Name"
          type="search"
          margin="normal"
          onChange={e => this.onChangeSearch(e.target.value)}
          onKeyPress={this.onEnter}
          value={searchField}
        />
        <TextField
          id="search"
          label="Search by Admin Email"
          type="search"
          margin="normal"
          onChange={e => this.onChangeAdmin(e.target.value)}
          onKeyPress={this.onEnter}
          style={{ margin: 10, width: 200 }}
          value={adminEmailField}
        />
        <SearchButton
          variant="raised"
          onClick={() => this.clearSearchOrganization()}
        >
          Clear
        </SearchButton>
        <SearchButton
          variant="contained"
          color="primary"
          onClick={() => this.onClickSearchOrganization()}
        >
          Search
        </SearchButton>
        <TableContainer>
          <TablePaper>
            {this.renderTable()}
            {this.renderEmpty()}
          </TablePaper>
        </TableContainer>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  meta: state.users.meta,
  organizations: state.organizations.organizations,
  ui: state.ui.uiState
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(OrganizationsActionCreators, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OrganizationsPage);



// WEBPACK FOOTER //
// ./src/pages/organizations/index.js